// -- React components
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'

// -- Redux components
import {Provider} from 'react-redux';
import configureStore from './redux/store/configureStore';
import { PersistGate } from 'redux-persist/es/integration/react'

// -- Application components
import Authenticator from './components/Authenticator';

// -- Theme components
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import {setClientPath} from './redux/actions/clientPath'

const store = configureStore();

const muiTheme = getMuiTheme({
	palette: {
		primary1Color: '#235CA6',
		accent1Color: '#343434',
	}
});

// -- set URL
const url = window.location.host.split(':');
if(url[0] === 'local.mijndp.nl' || url[0] === 'localhost') {
 	store.store.dispatch(setClientPath('http://local.mijndp.nl'));
} else {
 	store.store.dispatch(setClientPath('https://' + window.location.host));
}

window.Avantage = {};
window.Avantage.Collapse = function collapseSection(element) {
    element.style.height = 0 + 'px';
}

window.Avantage.Expand = function expandSection(element) {
    var sectionHeight = element.scrollHeight;
    element.style.height = sectionHeight + 'px';
}

var matchHeight = {
	match: function() {
		var groupName = Array.prototype.slice.call(document.querySelectorAll("[data-match-height]"));
		var groupHeights = {};

		for (var item of groupName) {
			var data = item.getAttribute("data-match-height");
			item.style.minHeight = "auto";

			if (groupHeights.hasOwnProperty(data)) {
				Object.defineProperty(groupHeights, data, {
					value: Math.max(groupHeights[data], item.offsetHeight),
					configurable: true,
					writable: true,
					enumerable: true
				});
			} else {
				groupHeights[data] = item.offsetHeight;
			}
		}

		var groupHeightsMax = groupHeights;

		Object.getOwnPropertyNames(groupHeightsMax).forEach(function(value) {
			var elementsToChange = document.querySelectorAll("[data-match-height='" + value + "']");

			for (var i = 0; i < elementsToChange.length; i++) {
				elementsToChange[i].style.minHeight = Object.getOwnPropertyDescriptor(groupHeightsMax, value).value + "px";
			}
		});
	},

	eventListeners: function() {
		window.addEventListener("resize", function() {
			matchHeight.match()
		});
	},

	init: function() {
		this.match();
	}
};


if(window.location.pathname === '/login') {
	
	store.persistor.purge();
}

window.Avantage.matchHeight = matchHeight;


ReactDOM.render(
	<Provider store={store.store}>
		<PersistGate persistor={store.persistor}>
			<BrowserRouter>
				<MuiThemeProvider muiTheme={muiTheme}>
					<Authenticator persistStore={store}/>
				</MuiThemeProvider>
			</BrowserRouter>
		</PersistGate>
	</Provider>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js